import { useMemo } from 'react'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'

import { AppMsgCode, Filter } from 'cat-shared/utils'
import { RootPage } from 'client/pages'
import { getLocalAuthUser, removeLocalAuthUser } from 'client/services'
import { useAppContext, usePageStateContext, useModalDialogContext } from 'client/hooks'
import { AppSnackBar } from 'client/ui-building-blocks'

const App = () => {
  const { setAuthUser } = useAppContext()
  const { setSettingsPageState, setBrowseQuestionsPageState, setRandomizerCategory } =
    usePageStateContext()
  const { closeAllModals } = useModalDialogContext()

  const onSettled = (data, err) => {
    const token = getLocalAuthUser?.().token

    if (
      (token && err?.msg?.code === AppMsgCode.AuthenticationFailed) ||
      (!token && err?.msg?.code === AppMsgCode.IllegalAction)
    ) {
      removeLocalAuthUser()
      setSettingsPageState({ tabNo: 1 })
      setBrowseQuestionsPageState(state => ({
        ...state,
        filter: Filter.Answered,
        category: 'any',
        search: '',
        pageNo: 1,
      }))
      setAuthUser(null)
      setRandomizerCategory('any')
      closeAllModals()
      window.location.reload()
    }
  }

  const queryClient = useMemo(() => {
    return new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: false,
          onSettled,
        },
        mutations: {
          retry: false,
          onSettled,
        },
      },
    })
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <div id="App">
        <AppSnackBar />
        <RootPage />
      </div>
      <ReactQueryDevtools />
    </QueryClientProvider>
  )
}

export default App
